/**
 * Created by jeffjing on 2017/6/22.
 */
import {getCookie} from './utils';
import value from './value';

export default {
    getUin,
    photoUrl,
    avatarUrl,
    photoSizeUrl,
    getStorage,
    setStorage,
    removeStorage,
    setStorageCache,
    getStorageCache,
    removeStorageCache: removeStorage
};


/**
 * 获取uin
 */
let _uin;
export function getUin() {
    if (typeof(_uin) === 'undefined' || _uin === '') {
    // 这里一定保证cookie种上了uin吗？如果没有，会报错
        if(!getCookie('uin')){
            console.error("没有登陆态，获取uin失败!");
            return _uin;
        }
        _uin = getCookie('uin').replace(/^[o0]+/i, '');
    }
    return _uin;
}

/* 根据图片id获取图片地址（用于语音封面、照片墙）*/
export function photoUrl(photoId, path = value.url.PHOTO_PATH) {
    return path.replace('{{id}}', photoId);
}

/* 根据avatarId获取图片地址 */
export function avatarUrl(avatarId, path = value.url.AVATAR_PATH, gender) {
    let url = '';

    if(path === 'default') {
        path = value.url.AVATAR_PATH;
    }

    if(avatarId) {
        if (!/^https?/.test(avatarId) && !/^\/\//.test(avatarId)) {
            url = path.replace('{{id}}', avatarId);
        } else {
            url = avatarId;
        }
        
    } else if(gender) {
        switch(gender) {
            case 1: 
                url = '//pub.idqqimg.com/pc/misc/files/20160920/044a1ffefb2543649d6444b6c3a6953a.png'
                break;
            case 2: 
                url = '//pub.idqqimg.com/pc/misc/files/20160920/5a99716e80e24f58b1e5a97a77288492.png';
                break;
            
        }
    }

    return url;
}

/* 根据size替换对应图片URL原本的size */
export function photoSizeUrl(photoUrl, size = 340) {
    return photoUrl && photoUrl.replace(/\/(\d*)$/, `/${size}`);
}


/*
@desc localStorage的增删查，带前缀
*/
var _storagePrefix = 'HY_';

export function setStorage(key, value, prefix = _storagePrefix) {
    key = prefix + key;
    localStorage.setItem(key, JSON.stringify(value));
}

export function getStorage(key, prefix = _storagePrefix) {
    key = prefix + key;
    var value = JSON.parse(localStorage.getItem(key));
    return value;
}

export function removeStorage(key, prefix = _storagePrefix) {
    key = prefix + key;
    localStorage.removeItem(key);
}

/*
 @desc 加载本地数据
 @key: String 本地数据的key
 @maxAge: Number 失效时间，单位毫秒
 */
export function getStorageCache(key, maxAge = 1000*60*60*24) {
    var storage = getStorage(key);

    if (!storage) return storage;

    var {value, date} = storage;

    if (maxAge) {
    // 超时，清除
        if (date + maxAge < +new Date()) {
            value = null;
        }
    }

    return value;
}

/*
 @desc 设置本地数据
 @key
 @value
 */
export function setStorageCache(key, value) {
    setStorage(key, {
        value: value,
        date: +new Date()
    });
}

/**
 * 验证是否是腾讯视频链接
 * @param {string} url 
 */
export function validTxVideoUrl(url) {
    var re = /v.qq/g
    return url.search(re) !== -1
}